import { Box, styled } from '@mui/material';

export const SectionInputs = styled(Box)`
  flex: 1 0 0;
  .add-logo {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 10px;
    gap: 10px;
    width: 440px;
    height: 60px;
    border: 1px dashed #bdbdbd;
    border-radius: 6px;
    width: 100%;
    margin-bottom: 20px;
  }
`;

export const PreviewArea = styled(Box)`
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    max-width: 100%;
    width: 250px;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;
